var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},_vm._l((_vm.allMovies),function(movie){return _c('MovieCard',{key:movie.id,attrs:{"movie":movie}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }